import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "convfact-ocr-purchase-dialog",
    templateUrl: "./ocr-purchase-dialog.component.html",
    styleUrls: ["./ocr-purchase-dialog.component.css"],
    standalone: false
})
export class OcrPurchaseDialogComponent {
  pages: number = 0;
  oneTimeCost: number = 0;

  constructor(
    public dialogRef: MatDialogRef<OcrPurchaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pages = data && data.pages ? Number(data.pages) : 0;
    this.oneTimeCost = data && data.oneTimeCost ? Number(data.oneTimeCost) : 0;
  }

  close(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
